module.exports = __webpack_public_path__ + "static/media/jam.1696d887.svg";